window.addEventListener('load', function(event) {
  // console.log('ann bar script');
  const annSlider = new Swiper('.hero', {
    wrapperClass: 'hero__track',
    slideClass: 'hero__slide',
    speed: 500,
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: '.hero__pagination',
      type: 'bullets',
    },
  });
}, false);